import React from 'react';
import './styles/App.css';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import AlgorithmSelector from './components/AlgorithmSelector';
import Canvas from './components/Canvas';

function App() {
  const [selectedAlgorithm, setSelectedAlgorithm] = React.useState(null);

  return (
    <div className="app">
      <Navigation onHome={selectedAlgorithm ? () => setSelectedAlgorithm(null) : null} />
      {selectedAlgorithm ? (
        <Canvas 
          algorithm={selectedAlgorithm} 
          onBack={() => setSelectedAlgorithm(null)}
          onSelectAlgorithm={setSelectedAlgorithm}
        />
      ) : (
        <>
          <Hero />
          <AlgorithmSelector onSelectAlgorithm={setSelectedAlgorithm} />
        </>
      )}
    </div>
  );
}

export default App;
